// extracted by mini-css-extract-plugin
export default {"button":"NewCategory_button__gE6ZH","divider":"NewCategory_divider__Ds2y0","link":"NewCategory_link__vbCKQ"};